module.exports = __webpack_public_path__ + "static/media/07_sognolucido.ebe4caff.jpg";